import { Button, Form, Input, Modal, Space, Upload } from "antd";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import axios from "axios";

const AddPaymentOnline = ({
  closeOriginalTab,
  open,
  close,
  total,
  po_number_id,
  invoice_number,
  getMerchantOrderSaveList,
}) => {
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const [loadings, setLoadings] = useState(false);
  const [fileList, setFileList] = useState([{}]);

  const handleChange = (info) => {
    let fileList = [...info.fileList];
    fileList = fileList.slice(-1);
    setFileList(fileList);
  };

  const handlePaymentOnline = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("po_number_id", po_number_id);
    formdata.append("invoice_number", invoice_number);
    formdata.append("image", values.file === undefined ? "" : values.file.file);
    formdata.append("amount", total);

    for (const name in values) {
      formdata.append(name, values[name]);
    }

    setLoadings(true);
    axios
      .post("user/merchant/payment-online", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Payment online successfully.");
          setTimeout(() => {
            close();
            closeOriginalTab();
            setLoadings(false);
            getMerchantOrderSaveList();
          }, 1000);
        }
      })
      .catch((error) => {
        setLoadings(false);
      });
  };

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      footer={null}
      width={350}
    >
      <Form
        layout="vertical"
        name="basic"
        onFinish={handlePaymentOnline}
        autoComplete="off"
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Form.Item
            label="Payment Attachment"
            name="file"
            rules={[
              {
                required: true,
                message: "Payment attachment image required",
              },
            ]}
          >
            <Upload
              beforeUpload={({ fileList: newFileList }) => {
                return false;
              }}
              onChange={handleChange}
              multiple={false}
              listType="picture-card"
              maxCount={1}
              showUploadList={{
                showRemoveIcon: false,
              }}
              fileList={fileList}
            >
              Upload
            </Upload>
          </Form.Item>

          <Form.Item
            label="Reference #"
            name="ref_no"
            rules={[
              {
                required: true,
                message: "Reference number required",
              },
            ]}
          >
            <Input placeholder="Set reference #" size="large" />
          </Form.Item>

          <Form.Item style={{ marginTop: "20px" }}>
            <Button
              type="primary"
              loading={loadings}
              htmlType="submit"
              style={{ width: "100%", borderRadius: "20px" }}
            >
              {loadings ? "Loading" : "Submit"}
            </Button>
          </Form.Item>
        </Space>
      </Form>
    </Modal>
  );
};

export default AddPaymentOnline;
